import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Try to load from local storage first
    registrationDetails: localStorage.getItem('registrationDetails')
        ? JSON.parse(localStorage.getItem('registrationDetails'))
        : null,
};

const memberSlice = createSlice({
    name: 'member',
    initialState,
    reducers: {
        setMemberDetails: (state, action) => {
            state.registrationDetails = action.payload;
            // Sync with local storage
            localStorage.setItem('registrationDetails', JSON.stringify(action.payload));
        },
        clearMemberDetails: (state) => {
            state.registrationDetails = null;
            // Clear from local storage
            localStorage.removeItem('registrationDetails');
        },
    },
});

export const { setMemberDetails, clearMemberDetails } = memberSlice.actions;

export default memberSlice.reducer;
